import { DrawerModal } from '@fagmobler/ui';
import FagmoblerRefinementList from './RefinementList';
import { StockFilter } from './StockFilter';
import PriceFilter from './PriceFilter';
// import Sorting from './Sorting';
import { TagsFilter } from './TagsFilter';
import { DynamicWidgets, RefinementList } from 'react-instantsearch';
import { SearchProps } from '@/lib/algolia/createCategorySearchProps';

export type DefaultProductFiltersProps = {
  children?: never;
  isOpen: boolean | 'sort';
  onClose: () => void;
  hideFacets?: SearchProps['hideFacets'];
};

export const DefaultProductFilters = ({
  onClose,
  isOpen,
  hideFacets,
}: DefaultProductFiltersProps) => {
  return (
    <DrawerModal
      isOpen={!!isOpen}
      onClose={onClose}
      title="Filtrer treff"
      unmount={false}
    >
      <div className="px-6">
        <DynamicWidgets>
          <FagmoblerRefinementList attribute="colour" label="Farge" />
          <FagmoblerRefinementList attribute="serie" label="Serie" />
          <FagmoblerRefinementList
            attribute="articleGroups.lvl1"
            label="Kategori"
          />
          <FagmoblerRefinementList
            attribute="material"
            label="Stoff og material"
          />
          <FagmoblerRefinementList
            attribute="width"
            label="Bredde"
            postfix=" cm"
          />
          <FagmoblerRefinementList
            attribute="length"
            label="Lengde"
            postfix=" cm"
          />
          <FagmoblerRefinementList
            attribute="height"
            label="Høyde"
            postfix=" cm"
          />
          <FagmoblerRefinementList
            attribute="depth"
            label="Dybde"
            postfix=" cm"
          />
          <FagmoblerRefinementList
            attribute="diameter"
            label="Diameter"
            postfix=" cm"
          />
          <FagmoblerRefinementList attribute="space" label="Plassbehov" />
          <FagmoblerRefinementList
            attribute="bedsize"
            label="Liggemål"
            postfix=" cm"
          />
        </DynamicWidgets>

        <PriceFilter />
        <StockFilter />

        <TagsFilter
          attribute="tags"
          operator="and"
          sortBy={['name:asc']}
          hideFacets={hideFacets}
          getLabel={(item) => {
            if (item.value === 'KUPP!') {
              return 'Medlemskupp';
            }
            return item.label;
          }}
        />
      </div>
    </DrawerModal>
  );
};

export default DefaultProductFilters;
